import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import t from '@instructure/quiz-i18n/es/format-message';
import { Breadcrumb, BreadcrumbLink } from '@instructure/ui-breadcrumb';
import ReactDOM from 'react-dom';
export var HeaderBreadCrumb = /*#__PURE__*/function (_Component) {
  function HeaderBreadCrumb() {
    var _this;
    _classCallCheck(this, HeaderBreadCrumb);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, HeaderBreadCrumb, [].concat(args));
    _defineProperty(_this, "setItemBanksRef", function (node) {
      _this.itemBanksRef = node;
    });
    return _this;
  }
  _inherits(HeaderBreadCrumb, _Component);
  return _createClass(HeaderBreadCrumb, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (this.props.navigateToBuild && this.props.navigateToBanks && this.itemBanksRef) {
        ReactDOM.findDOMNode(this.itemBanksRef).focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        returnToUrl = _this$props.returnToUrl,
        scope = _this$props.scope,
        navigateToBanks = _this$props.navigateToBanks,
        renderIcon = _this$props.renderIcon,
        setItemBanksRef = _this$props.setItemBanksRef,
        children = _this$props.children;
      var isScopeEmpty = !Object.keys(scope).length;
      var canvasReferrerLinkText = isScopeEmpty ? null : scope.title;
      var canvasReferrerLink = returnToUrl && canvasReferrerLinkText && /*#__PURE__*/React.createElement(BreadcrumbLink, {
        key: "Context",
        href: returnToUrl,
        target: "_top"
      }, canvasReferrerLinkText);
      var banksLink = /*#__PURE__*/React.createElement(BreadcrumbLink, {
        key: "Banks",
        onClick: navigateToBanks,
        renderIcon: renderIcon,
        ref: setItemBanksRef || this.setItemBanksRef
      }, t('Item Banks'));

      // If Breadcrumb has multiple children (even if 2nd is null), it will
      // render the `>` icon, which we don't want if there are no children.
      var breadCrumbLinks = [banksLink];
      if (children) {
        breadCrumbLinks = breadCrumbLinks.concat(children);
      }
      if (canvasReferrerLink) breadCrumbLinks.unshift(canvasReferrerLink);
      return /*#__PURE__*/React.createElement(Breadcrumb, {
        label: t('You are here:'),
        size: this.props.isCompact ? 'small' : 'medium'
      }, breadCrumbLinks);
    }
  }]);
}(Component);
_defineProperty(HeaderBreadCrumb, "propTypes", {
  returnToUrl: PropTypes.string,
  scope: PropTypes.objectOf(PropTypes.shape({
    type: PropTypes.string,
    uuid: PropTypes.string,
    title: PropTypes.string
  })),
  navigateToBuild: PropTypes.func,
  navigateToBanks: PropTypes.func,
  isCompact: PropTypes.bool,
  setItemBanksRef: PropTypes.func,
  renderIcon: PropTypes.node,
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node])
});
_defineProperty(HeaderBreadCrumb, "defaultProps", {
  returnToUrl: null,
  scope: {},
  navigateToBuild: null,
  navigateToBanks: null,
  isCompact: false,
  setItemBanksRef: null,
  renderIcon: null,
  children: null
});
export default HeaderBreadCrumb;